import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TemplatePage from "./pages/Template";
import AuthProtectedPage from "./pages/ExamplePage";
import AuthProtection from "./Components/Auth";


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TemplatePage />}></Route>
        <Route path="/example" element={<AuthProtection />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);